import { $http } from "@/utils/http";
import {
    SET_ARTICLES_LIST,
    SET_ARTICLES_LIST_LOADING,
    SET_ARTICLES_ITEM,
    SET_ARTICLES_ITEM_LOADING,
    CHANGE_SKIP,
    SET_LIST_LENGTH,
    CHANGE_CATEGORY,
    SET_RANDOM_ARTICLES_LIST_LOADING,
    SET_RANDOM_ARTICLES_LIST,
    SET_RANDOM_LIST_LENGTH,
    SET_ARTICLES_CATEGORY_LIST,
    SET_CURRENT_CATEGORY_ARTICLES,
    SET_CURRENT_ARTICLES_ID,
    SET_CURRENT_ARTICLES_LENGTH,
    CLEAR_ARTICLES_SKIP,
    SING_IN_WITH_EMAIL_LOADING,
    SET_TOKEN,
    SET_LOADING_FEEDBACK,
    SET_CURRENT_ARTICLES_LOADING,
} from "../mutation-types";

import {
    GET_ARTICLES_LIST,
    GET_ARTICLES_ITEM,
    GET_RANDOM_ARTICLES_LIST,
    GET_ARTICLES_LIST_CATEGORY,
    GET_ARTICLES_CURRENT_CATEGORY,
    SEND_DATA_FROM_POPUPS,
    LOGIN_BY_TOKEN,
    SEND_FEEDBACK,
} from "../action-types";

const state = {
    articlesList: null,
    articlesItem: null,
    articlesListLoading: false,
    articlesItemLoading: false,
    randomArticlesList: null,
    randomArticlesListLoading: false,
    randomArticlesListLength: 0,
    skip: 3,
    limit: 3,
    randomLimit: 5,
    listLength: 0,
    activeCategory: "",
    articlesCategoryList: "",
    currentCategoryArticles: "",
    latestArticlesLength: "",
    currentArticlesId: "",
    currentArticlesLength: "",
    currentArticlesLoading: false,
};

const getters = {
    currentArticlesLoading: state => state.currentArticlesLoading,
    currentArticlesLength: state => state.currentArticlesLength,
    currentArticlesId: state => state.currentArticlesId,
    latestArticlesLength: state => state.latestArticlesLength,
    currentCategoryArticles: state => state.currentCategoryArticles,
    articlesCategoryList: state => state.articlesCategoryList,
    articlesList: state => state.articlesList,
    articlesListLoading: state => state.articlesListLoading,
    articlesItem: state => state.articlesItem,
    articlesItemLoading: state => state.articlesItemLoading,
    randomArticlesList: state => state.randomArticlesList,
    randomArticlesListLength: state => state.randomArticlesListLength,
    randomArticlesListLoading: state => state.randomArticlesListLoading,
    randomLimit: state => state.randomLimit,
    skip: state => state.skip,
    limit: state => state.limit,
    listLength: state => state.listLength,
    activeCategory: state => state.activeCategory,
};

const actions = {
    [SEND_DATA_FROM_POPUPS]: async ({ commit }, data) => {
        commit(SET_CURRENT_ARTICLES_LOADING, true);
        try {
            return await $http.post("v1/banners_feedback", data);
        } catch (e) {
            throw e;
        } finally {
        }
    },

    [GET_ARTICLES_CURRENT_CATEGORY]: async ({ commit }, id) => {
        commit(SET_CURRENT_ARTICLES_LOADING, true);
        try {
            const response = await $http.get(`v1/articles?per-page=${state.skip}&category=${id}`);
            commit(SET_CURRENT_CATEGORY_ARTICLES, response.data.data);
            commit(SET_CURRENT_ARTICLES_LENGTH, response.data.meta.total);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(SET_CURRENT_ARTICLES_LOADING, false);
        }
    },
    [GET_ARTICLES_LIST_CATEGORY]: async ({ commit }) => {
        try {
            const response = await $http.get(`v1/articles_categories`);
            commit(SET_ARTICLES_CATEGORY_LIST, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
        }
    },
    [GET_ARTICLES_LIST]: async ({ commit }, limit) => {
        commit(SET_ARTICLES_LIST_LOADING, true);
        try {
            // commit(CHANGE_SKIP);
            const response = await $http.get(`v1/articles?per-page=${limit}`);
            commit(SET_ARTICLES_LIST, response.data.data);
            commit(SET_LIST_LENGTH, response.data.meta.total);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(SET_ARTICLES_LIST_LOADING, false);
        }
    },
    [GET_RANDOM_ARTICLES_LIST]: async ({ commit }, payload) => {
        commit(SET_RANDOM_ARTICLES_LIST_LOADING, true);
        try {
            const response = await $http.post(`v1/random-articles?count=${state.randomLimit}&except=${payload.id}`);
            commit(SET_RANDOM_ARTICLES_LIST, response.data.data);
            commit(SET_RANDOM_LIST_LENGTH, response.data.data.length);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(SET_RANDOM_ARTICLES_LIST_LOADING, false);
        }
    },
    [GET_ARTICLES_ITEM]: async ({ commit }, payload) => {
        commit(SET_ARTICLES_ITEM_LOADING, true);
        try {
            const response = await $http.get(`v1/article/${payload.slug}`);
            commit(SET_ARTICLES_ITEM, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_ARTICLES_ITEM_LOADING, false);
        }
    },
};

const mutations = {
    [SET_ARTICLES_LIST](state, list) {
        state.articlesList = list;
    },
    [SET_ARTICLES_LIST_LOADING](state, status) {
        state.articlesListLoading = status;
    },
    [SET_RANDOM_ARTICLES_LIST](state, list) {
        state.randomArticlesList = list;
    },
    [SET_RANDOM_ARTICLES_LIST_LOADING](state, status) {
        state.randomArticlesListLoading = status;
    },
    [SET_RANDOM_LIST_LENGTH](state, data) {
        state.listLength = data;
    },
    [SET_ARTICLES_ITEM](state, data) {
        state.articlesItem = data;
    },
    [SET_ARTICLES_ITEM_LOADING](state, status) {
        state.articlesItemLoading = status;
    },
    [SET_LIST_LENGTH](state, data) {
        state.latestArticlesLength = data;
    },
    [CHANGE_SKIP](state) {
        state.skip += state.limit;
    },
    [CHANGE_CATEGORY](state, category) {
        state.activeCategory = category;
        state.skip = 3;
        state.listLength = 0;
        state.list = null;
    },
    [SET_ARTICLES_CATEGORY_LIST](state, data) {
        state.articlesCategoryList = data;
    },
    [SET_CURRENT_CATEGORY_ARTICLES](state, data) {
        state.currentCategoryArticles = data;
    },
    [SET_CURRENT_ARTICLES_ID](state, data) {
        state.currentArticlesId = data;
    },
    [SET_CURRENT_ARTICLES_LENGTH](state, data) {
        state.currentArticlesLength = data;
    },
    [CLEAR_ARTICLES_SKIP](state) {
        state.skip = 3;
    },
    [SET_CURRENT_ARTICLES_LOADING](state, status) {
        state.currentArticlesLoading = status;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
